import content from './content.js';
import custom_profile_fields from './custom-profile-fields.js';
import sign_up_and_sign_in from './sign-up-and-sign-in.js';
const sign_in_exp = {
    page_title: '登錄體驗',
    page_title_with_account: '登錄與帳戶',
    title: '登錄與帳戶',
    description: '自定義身份驗證流程和 UI，並實時預覽開箱即用的體驗。',
    tabs: {
        branding: '品牌',
        sign_up_and_sign_in: '註冊與登錄',
        collect_user_profile: '收集用戶資料',
        account_center: '帳戶中心',
        content: '內容',
        password_policy: '密碼政策',
    },
    welcome: {
        title: '自定義登錄體驗',
        description: '通過首次登錄設置快速入門。本指南將帶領你完成所有必要的設置。',
        get_started: '開始',
        apply_remind: '請注意，登錄體驗將會應用到當前帳戶下的所有應用。',
    },
    color: {
        title: '顏色',
        primary_color: '品牌顏色',
        dark_primary_color: '品牌顏色 (深色)',
        dark_mode: '開啟深色模式',
        dark_mode_description: '基於品牌顏色和 Logto 的算法，應用將會有一個自動生成的深色模式。當然，你可以自定義和修改。',
        dark_mode_reset_tip: '基於品牌顏色，重新生成深色模式顏色。',
        reset: '重新生成',
    },
    branding: {
        title: '品牌定制區',
        ui_style: '樣式',
        with_light: '{{value}}',
        with_dark: '{{value}} (深色)',
        app_logo_and_favicon: '應用程式標誌和圖標',
        company_logo_and_favicon: '公司標誌和圖標',
        organization_logo_and_favicon: '組織標誌和圖標',
        hide_logto_branding: '隱藏 Logto 品牌',
        hide_logto_branding_description: '移除「Powered by Logto」。以乾淨、專業的登入體驗突顯你的品牌。',
        hide_logto_branding_oss_note: '此功能可在 <a>Logto Cloud</a> 或<selfHosted>自託管方案</selfHosted>中使用。',
    },
    branding_uploads: {
        app_logo: {
            title: '應用程式標誌',
            url: '應用程式標誌 URL',
            url_placeholder: 'https://your.cdn.domain/logo.png',
            error: '應用程式標誌：{{error}}',
        },
        company_logo: {
            title: '公司標誌',
            url: '公司標誌 URL',
            url_placeholder: 'https://your.cdn.domain/logo.png',
            error: '公司標誌：{{error}}',
        },
        organization_logo: {
            title: '上傳圖片',
            url: '組織標誌 URL',
            url_placeholder: 'https://your.cdn.domain/logo.png',
            error: '組織標誌：{{error}}',
        },
        connector_logo: {
            title: '上傳圖片',
            url: '連接器標誌 URL',
            url_placeholder: 'https://your.cdn.domain/logo.png',
            error: '連接器標誌：{{error}}',
        },
        favicon: {
            title: '圖標',
            url: '圖標 URL',
            url_placeholder: 'https://your.cdn.domain/favicon.ico',
            error: '圖標：{{error}}',
        },
    },
    custom_ui: {
        title: '自定義 UI',
        cloud_tag: 'Cloud',
        css_code_editor_title: '自定義 CSS',
        css_code_editor_field_title: 'CSS 覆寫',
        css_code_editor_description1: '查看自定義 CSS 示例。',
        css_code_editor_description2: '<a>{{link}}</a>',
        css_code_editor_description_link_content: '了解更多',
        css_code_editor_content_placeholder: '在此輸入你的 CSS 覆寫規則，以按你的具體要求調整任何內容的樣式。發揮你的創意，讓你的 UI 脫穎而出。',
        bring_your_ui_title: '帶上你的 UI',
        bring_your_ui_upload_title: '上傳自訂 UI 資源',
        bring_your_ui_description: '上傳壓縮包 (.zip) 以用自己的代碼替換 Logto 預建的 UI。<a>了解更多</a>',
        bring_your_ui_oss_description: '用你的代碼自訂登入 UI。',
        bring_your_ui_oss_card_description: '自訂 UI 上傳功能可在 <a>Logto Cloud</a> 或<selfHosted>自託管方案</selfHosted>中使用。無需 fork 和重新部署。',
        bring_your_ui_oss_try_cloud: '試用 Cloud',
        preview_with_bring_your_ui_description: '你的自定義 UI 資源已成功上傳，現在正在提供服務。因此，內建預覽窗口已被禁用。\n要測試你的個性化登錄 UI，請點擊“實時預覽”按鈕在新瀏覽器標籤頁中打開。',
        csp_description: '為你的自訂登入 UI 允許額外的來源表達式。這些值只會在提供自訂 UI 資源時套用。',
        csp_script_src: '允許的 script-src',
        csp_script_src_tip: '允許你的自訂 UI 載入腳本時使用的 HTTPS 來源表達式，例如 https://scripts.example.com 或 https://*.example.com。',
        csp_connect_src: '允許的 connect-src',
        csp_connect_src_tip: '允許你的自訂 UI 發送網絡請求時使用的 HTTPS 或 WSS 來源表達式，例如 https://api.example.com 或 wss://events.example.com。',
        csp_source_invalid_error: '請輸入有效的來源表達式。請使用 https:// URL；connect-src 亦支援 wss://。不支援 CSP 關鍵字和分號。',
        csp_source_duplicate_error: '此來源表達式已在列表中。',
        coop_tip: '將你的自訂登入 UI 與跨來源視窗隔離。只會在提供自訂 UI 資源時套用。',
        coop_unsafe_none: '未設定（無標頭）',
        coop_warning: '在彈出視窗中開啟登入頁並依賴 window.opener 的應用程式將無法正常運作。自訂 UI 開啟的彈出視窗在返回自訂 UI 時（例如社交登入回調）亦會失去 window.opener；使用 same-origin 時，彈出視窗一開啟就會失去它。',
    },
    account_center: {
        recent_authentication: {
            title: '最近一次身分驗證',
            description: '敏感帳號操作（例如修改密碼或關閉雙重驗證）要求使用者最近登入過，無論是在 Account Center 中操作，還是在呼叫 Account API 的應用程式中操作。此時間視窗定義了多久以內的登入仍視為最近登入。',
            maximum_authentication_age_in_minutes: '最大身分驗證時長（分鐘）',
            maximum_authentication_age_in_minutes_tip: '登入在多長時間內仍視為對敏感操作足夠新。用戶端仍可透過 `max_age` 參數要求更短的時間視窗。',
        },
        title: '帳戶中心',
        description: '使用 Logto API 自訂你的帳戶中心流程。',
        enable_account_api: '啟用帳戶中心和 Account API',
        enable_account_api_description: '同時啟用面向使用者的 Account API 和 Logto 的開箱即用帳戶中心。關閉後，這兩項功能都將不可用。',
        field_options: {
            off: '關閉',
            edit: '可編輯',
            read_only: '唯讀',
            enabled: '已啟用',
            disabled: '已停用',
        },
        sections: {
            account_security: {
                title: '帳戶安全',
                description: '管理對 Account API 的存取權限，讓使用者在登入應用程式後，可以檢視或編輯身份資訊與驗證因素。',
                security_verification: {
                    title: '安全驗證',
                    description: '在變更安全設定之前，使用者必須驗證身份以取得有效期 10 分鐘的驗證紀錄 ID。要啟用驗證方式（電郵、手機、密碼），請將下方的 Account API 權限設定為<strong>唯讀</strong>（最低要求）或<strong>可編輯</strong>，以便系統偵測使用者是否已配置。<a>了解更多</a>',
                    description_step_up: '變更安全設定前，內置 Account Center 要求使用者最近登入過。如果目前登入時間早於設定的最近一次身分驗證時間視窗，Account Center 會發起 OIDC step-up，並要求使用者驗證身分。要允許使用者在 Account Center 中查看或管理驗證方式（電郵、手機或密碼），請將下方對應的 Account API 權限設定為<strong>唯讀</strong>或<strong>可編輯</strong>。對於這些敏感操作，直接呼叫 Account API 的應用程式仍可使用驗證紀錄 ID。<a>了解更多</a>',
                },
                groups: {
                    identifiers: {
                        title: '身份識別',
                    },
                    authentication_factors: {
                        title: '驗證因素',
                    },
                    session_management: {
                        title: '會話管理',
                    },
                    developer_settings: {
                        title: '開發者設定',
                    },
                },
            },
            user_profile: {
                title: '使用者檔案',
                description: '管理對 Account API 的存取，讓使用者在登入後可以檢視或編輯基礎或自訂的檔案資料。',
                groups: {
                    profile_data: {
                        title: '檔案資料',
                    },
                },
            },
            secret_vault: {
                title: '密鑰保險庫',
                description: '適用於社交及企業連接器，安全儲存第三方存取權杖以呼叫其 API（例如新增事件至 Google 日曆）。',
                third_party_token_storage: {
                    title: '第三方權杖',
                    third_party_access_token_retrieval: '第三方存取權杖擷取',
                    third_party_token_tooltip: '如需儲存權杖，可在相應的社交或企業連接器設定中啟用此選項。',
                    third_party_token_description: '啟用 Account API 後，第三方權杖擷取會自動啟用。',
                },
            },
        },
        fields: {
            email: '電郵地址',
            phone: '電話號碼',
            social: '社交身份',
            password: '密碼',
            mfa: '多重驗證',
            mfa_description: '允許使用者於帳戶中心管理其多重驗證方式。',
            passkey: 'Passkey',
            username: '使用者名稱',
            name: '姓名',
            avatar: '頭像',
            profile: '檔案',
            profile_description: '控制對結構化檔案屬性的存取權。',
            custom_data: '自訂資料',
            custom_data_description: '控制對儲存在使用者上的自訂 JSON 資料的存取權。',
            sessions: '會話',
            trusted_devices: '受信任裝置',
            personal_access_tokens: '個人存取權杖',
            personal_access_tokens_description: '啟用後，用戶可以建立長期有效的個人存取權杖；這些權杖在登出和重設密碼後仍然有效，並且可被任何啟用了權杖交換的第一方應用程式兌換為存取權杖。',
        },
        profile_fields: {
            title: '預構建帳戶中心的檔案欄位',
            add_profile_fields: '新增檔案欄位',
            hint: {
                not_in_list: '沒有你想要的？',
                set_up: '立即設定',
                go_to: '其他檔案欄位。',
            },
            disabled_hint: {
                name: '要新增此欄位，請先在下方用戶資料部分中將「姓名」權限設定為「可編輯/唯讀」。',
                avatar: '要新增此欄位，請先在下方用戶資料部分中將「頭像」權限設定為「可編輯/唯讀」。',
                profile: '要新增此欄位，請先在下方用戶資料部分中將「檔案」權限設定為「可編輯/唯讀」。',
                custom_data: '要新增此欄位，請先在下方用戶資料部分中將「自訂資料」權限設定為「可編輯/唯讀」。',
            },
        },
        webauthn_related_origins: 'WebAuthn 關聯來源',
        webauthn_related_origins_description: '新增允許透過 Account API 註冊通行密鑰的前端應用程式網域。',
        webauthn_related_origins_error: '來源必須以 https:// 或 http:// 開頭',
        delete_account_url: '刪除帳號',
        delete_account_url_description: '提供你自己的端點 URL，以使用自訂邏輯處理帳號刪除。',
        prebuilt_ui: {
            title: '整合預建 UI',
            description: '快速整合帳戶中心、安全驗證或單一資料更新流程等開箱即用的流程。',
            permission_notice: '要整合這些預建流程，請在下方設定中將相關的帳戶 API 權限設為<strong>編輯</strong>。',
            account_center_title: '整合開箱即用的帳戶中心',
            account_center_description: '將用戶路由到帳戶中心，以管理電郵地址、電話號碼、使用者名稱、密碼、MFA 和關聯帳號等安全設定。',
            flows_title: '整合開箱即用的安全設置流程',
            single_task_flows_title: '整合開箱即用的單一資料更新流程',
            flows_description: '結合你的域名與路徑形成你的帳戶設置 URL（例如，https://auth.foo.com/account/email）。可以選擇性地添加 `redirect=` 在成功更新後返回用戶至你的應用程式，添加 `show_success=true` 以保持成功頁面可見，添加 `ui_locales=` 以覆蓋預設語言，添加 `login_hint=` 以在登入頁面預填識別碼，或添加 `identifier=` 以在電郵、電話或用戶名稱路徑中預填新的值。',
            single_task_flows_description: '直接將用戶導向特定流程（例如，電郵綁定）。可以選擇性地添加 `redirect=` 在成功更新後返回用戶至你的應用程式，添加 `show_success=true` 以保持成功頁面可見，添加 `ui_locales=` 以覆蓋預設語言，添加 `login_hint=` 以在登入頁面預填識別碼，或添加 `identifier=` 以在電郵、電話或用戶名稱路徑中預填新的值。',
            tooltips: {
                email: '更新你的主電郵地址',
                phone: '更新你的主電話號碼',
                username: '更新你的使用者名稱',
                password: '設置新密碼',
                social: '連結社交帳號以供登入',
                social_change: '切換至另一個已連結的社交帳號',
                social_remove: '移除已連結的社交帳號',
                authenticator_app: '設置多因素驗證的新的身份驗證應用',
                authenticator_app_replace: '用新的身份驗證應用替換你現有的身份驗證應用',
                passkey_add: '註冊新的通行密鑰',
                passkey_manage: '管理你現有的通行密鑰或添加新的',
                backup_codes_generate: '生成一組新的 10 個備份代碼',
                backup_codes_manage: '查看可用的備份代碼或生成新的',
                account_center: '訪問帳戶中心以管理電郵地址、電話號碼、使用者名稱、密碼、MFA 和關聯帳號等安全設定',
                profile: '管理個人資料（如姓名、頭像）的中心樞紐',
                sessions: '查看和管理你在各裝置上的活躍會話',
            },
            customize_note: '不想要開箱即用的體驗？你可以完全',
            customize_link: '使用 Account API 自定義你的流程。',
        },
        custom_css: {
            title: '自定義 CSS',
            description: '使用自定義 CSS 自定義帳戶中心的外觀。',
        },
    },
    sign_up_and_sign_in,
    content,
    setup_warning: {
        no_connector_sms: '尚未設置 SMS 短信連接器。在完成該配置前，用戶將無法通過此登錄方式登錄。<a>{{link}}</a>連接器。',
        no_connector_email: '尚未設置電子郵件連接器。在完成該配置前，用戶將無法通過此登錄方式登錄。<a>{{link}}</a>連接器。',
        no_connector_social: '你還沒有設置任何社交連接器。首先添加連接器以應用社交登錄方法。<a>{{link}}</a>連接器。',
        no_connector_email_account_center: '尚未設置電子郵件連接器。請在<a>「郵件與短信連接器」</a>中設置。',
        no_connector_sms_account_center: '尚未設置 SMS 短信連接器。請在<a>「郵件與短信連接器」</a>中設置。',
        no_connector_social_account_center: '尚未設置社交連接器。請在<a>「社交連接器」</a>中設置。',
        no_mfa_factor: '尚未設置 MFA 因子。請在<a>{{link}}</a>中完成設定。',
        setup_link: '立即設置',
    },
    save_alert: {
        description: '你正在進行登錄註冊設置的變更。當前你的所有用戶會受到新設置的影響。確認保存該設置嗎？',
        before: '設置前',
        after: '設置後',
        sign_up: '註冊',
        sign_in: '登錄',
        social: '社交',
        forgot_password_migration_notice: '我們已升級忘記密碼驗證以支援自訂方法。之前，這是由你的電子郵件和短信連接器自動確定的。點擊<strong>確認</strong>以完成升級。',
    },
    preview: {
        title: '登錄預覽',
        live_preview: '實時預覽',
        live_preview_tip: '保存以預覽更改',
        native: '移動原生',
        desktop_web: '桌面網頁',
        mobile_web: '移動網頁',
        desktop: '桌面網頁',
        mobile: '移動設備',
    },
    custom_profile_fields,
};
export default Object.freeze(sign_in_exp);
